import { type DialogProps, TextField } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ClassifierValue } from "../../../services/api/instances/classificatorApi/types";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { TransferObjectModal } from "../../Modals/TransferObjectModal";
import { FolderSelection } from "../../Modals/TransferObjectModal/Components/FolderSelection";
import { getFilteredOption } from "../../Modals/TransferObjectModal/helpers";
import { useTransferModal } from "../../Modals/TransferObjectModal/hooks/use-transfer-modal";
import type { TransferActions } from "../../Modals/TransferObjectModal/types";
import {
  deleteChildrenAction,
  updateClassifierWithChildrenAction,
} from "../redux/actions/actions";
import { selectClassifiers } from "../redux/selectors";
import {
  setClassifiersAction,
  setSelectedClassifierAction,
} from "../redux/slice";
import styles from "./styles.module.css";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

const actions: TransferActions<ClassifierValue> = {
  updateObjectWithChildren: updateClassifierWithChildrenAction,
  deleteChild: deleteChildrenAction,
  setObjects: setClassifiersAction,
  setSelectedObject: setSelectedClassifierAction,
};

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const TransferClassifierModal: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const classifiers = useAppSelector(selectClassifiers);
  const { handleTransfer, targetFolder, objects, handleSelectChange } =
    useTransferModal<ClassifierValue>(classifiers, actions);
  const { t } = useTranslation();
  return (
    <TransferObjectModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
        handleTransfer(childId as string);
      }}
      {...props}
    >
      <div className={styles.container}>
        <FolderSelection
          options={getFilteredOption(objects)}
          value={targetFolder}
          inputValue={targetFolder?.friendly_name}
          getOptionLabel={(option: StorageObject<ClassifierValue>) =>
            option.friendly_name
          }
          onChange={handleSelectChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"outlined"}
              placeholder={t("transfer_modal.input_placeholder")}
            />
          )}
        />
      </div>
    </TransferObjectModal>
  );
};
